export default {
  baseURL: process.env.VUE_APP_URL,
  baseMediaURL: process.env.VUE_APP_MEDIA_URL,
  baseCloudinary: 'https://res.cloudinary.com/kek-fotok/image/upload'
}
